import * as React from "react";

import { useAnalytics, useAuth, useNavigation } from "@/providers";
import { ActionRecord, ActionReference } from "@/shared/domain/actions";
import { ACTION_VERB_ICONS } from "@/shared/foundation/icons";
import { RobotoButton } from "@/shared/foundation/primitives";

const RunIcon = ACTION_VERB_ICONS.run;

export interface InvokeActionButtonProps {
  action?: ActionRecord;
  datasetId?: string;
}

/**
 * The secondary "Invoke" button: opens the invoke page, prefilled with
 * `action` and `datasetId` when given. Disabled for an action with no image.
 */
export default function InvokeActionButton({
  action,
  datasetId,
}: InvokeActionButtonProps) {
  const { currentOrganization } = useAuth();
  const { goto } = useNavigation();
  const { trackEvent } = useAnalytics();
  const onClick = React.useCallback(() => {
    let actionReference: ActionReference | undefined = undefined;
    if (action) {
      actionReference = {
        name: action.name,
      };
      if (currentOrganization?.org_id !== action.org_id) {
        actionReference.owner = action.org_id;
      }
    }
    trackEvent("InvokeActionClicked", { name: action?.name ?? "" });
    goto.invokeAction({
      action: actionReference,
      datasetId,
    });
  }, [currentOrganization?.org_id, action, datasetId, goto, trackEvent]);

  return (
    <RobotoButton
      variant="secondary"
      icon={<RunIcon aria-hidden data-action-verb="run" />}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      disabled={action !== undefined && !action.uri}
    >
      Invoke
    </RobotoButton>
  );
}
